import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { type IpRestrictionRadioValue } from './ipRestrictionRadio';

export type RestrictIpSettingFormValues = {
  ip_address_restriction_enabled: IpRestrictionRadioValue;
};

export type { IpRestrictionRadioValue } from './ipRestrictionRadio';

export const useRestrictIpSettingForm = (
  ipRestrictionServerMode: IpRestrictionRadioValue
) => {
  const syncedValues = useMemo(
    (): RestrictIpSettingFormValues => ({
      ip_address_restriction_enabled: ipRestrictionServerMode,
    }),
    [ipRestrictionServerMode]
  );

  return useForm<RestrictIpSettingFormValues>({
    defaultValues: syncedValues,
    values: syncedValues,
    mode: 'all',
  });
};
